/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_ServicesInputs */

const en_directory_search_services = /** @type {(inputs: Directory_Search_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services`)
};

const pl_directory_search_services = /** @type {(inputs: Directory_Search_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usługi`)
};

/**
* | output |
* | --- |
* | "Services" |
*
* @param {Directory_Search_ServicesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_services = /** @type {((inputs?: Directory_Search_ServicesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_ServicesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_services(inputs)
	return en_directory_search_services(inputs)
});